(function(){'use strict';
var XN='479164e8ef0ed25da64bb1b573069b6b84f58cadf3020a1dcf3a8e9963badc88';
var XM='66b391bae3d8a2fe6d3a27f4cbd62af2fa407c5033c7fc8bc4917a88d845eb0a1870c5264658a222909ee073c6e7dbb5';
var ZOHO_URL='https://crm.zoho.in/crm/WebToLeadForm';

function postToZoho(fields,returnURL){
  var p=new URLSearchParams();
  p.append('xnQsjsdp',XN);
  p.append('xmIwtLD',XM);
  p.append('actionType','TGVhZHM=');
  p.append('returnURL',returnURL||window.location.href);
  Object.keys(fields).forEach(function(k){p.append(k,fields[k]||'');});
  fetch(ZOHO_URL,{method:'POST',mode:'no-cors',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:p.toString()}).catch(function(){});
}

/* 1. NEWSLETTER — intercept submit, post to Zoho, show inline success */
document.addEventListener('submit',function(e){
  var f=e.target;
  if(!f||!f.classList.contains('newsletter-form'))return;
  var ei=f.querySelector('input[name="contact[email]"]');
  var em=ei?ei.value.trim():'';
  if(!em)return;
  e.preventDefault();
  postToZoho({
    'Company':'Newsletter Subscriber',
    'First Name':'Newsletter',
    'Last Name':'Subscriber',
    'Email':em,
    'Mobile':'',
    'Lead Source':'Newsletter',
    'Description':'Source: Newsletter Subscription - cadabraindia.co\nEmail: '+em+'\nInquiry Type: Newsletter Subscription'
  },window.location.origin+'/?nl=1');
  // Show inline success
  var btn=f.querySelector('button[type="submit"],input[type="submit"]');
  if(btn){btn.textContent='Subscribed ✓';btn.disabled=true;}
  if(ei)ei.value='';
},true);

/* 2. GET PROPOSAL — fire background Zoho post when success banner appears */
function watchGPForm(){
  var r=document.getElementById('gp-result');
  var f=document.getElementById('gp-form');
  if(!r||!f)return;
  var fired=false;
  var obs=new MutationObserver(function(muts){
    muts.forEach(function(m){
      if(fired)return;
      if(m.attributeName==='style'&&r.style.display!=='none'){
        fired=true;
        var g=function(n){return(f.querySelector('[name="'+n+'"]')||{}).value||'';};
        var sc=g('si_company'),sn=g('si_contact_name'),se=g('si_email'),
            sm=g('si_mobile'),sy=g('si_city'),sg=g('si_gstin'),
            sd=g('si_designation'),so=g('si_oems'),
            ec=g('eu_company'),ei=g('eu_industry'),el=g('eu_location'),
            ev=g('eu_value'),en=g('eu_line_items'),eo=g('eu_notes');
        var np=sn.trim().split(' ');
        postToZoho({
          'Company':sc||'Get Proposal Lead',
          'First Name':np[0]||'-',
          'Last Name':np.slice(1).join(' ')||'-',
          'Email':se,
          'Mobile':sm,
          'Address - City':sy,
          'Lead Source':'Web Form',
          'Description':'Source: Get Proposal Form - cadabraindia.co\nCompany: '+sc+'\nDesignation: '+sd+'\nGSTIN: '+sg+'\nOEMs: '+so+'\nEnd User: '+ec+'\nIndustry: '+ei+'\nProject Location: '+el+'\nProject Value: '+ev+'\nBOQ Items: '+en+'\nNotes: '+eo
        },window.location.href);
        obs.disconnect();
      }
    });
  });
  obs.observe(r,{attributes:true,attributeFilter:['style']});
}
document.addEventListener('DOMContentLoaded',watchGPForm);

})();